module.exports = __webpack_public_path__ + "img/audio_classify3.6d1c492c.png";